global.React = require("react");
global.ReactDOM = require("react-dom");
global.FlashNoticeContainer = require("./flash_wrapper");